import React from 'react'
import { BankTransferPaymentAnswer } from './BankTransferPaymentAnswer'

export const PaymentAnswer = ({ formData }) => {
  const selectKindPayment = {
    bank_transfer: <BankTransferPaymentAnswer formData={formData} />
  }
  return selectKindPayment[formData.selected_kind_payment]
}
